import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Header } from "../components/landing/Header";
import { Footer } from "../components/landing/Footer";

const API = process.env.REACT_APP_BACKEND_URL;
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const STATUS_LABEL = {
  processing: "Processing",
  shipped: "Shipped",
  ready_for_pickup: "Ready for pickup",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export default function TrackOrderPage() {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const t = searchParams.get("t") || "";
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/track/${encodeURIComponent(orderId)}`, { params: { t } })
      .then((r) => setOrder(r.data))
      .catch(() => setErr("We couldn't find that order. Check the link in your email."));
  }, [orderId, t]);

  return (
    <main data-testid="track-order-page">
      <Header />
      <section className="pt-[164px] pb-24 lg:pt-[196px] max-w-2xl mx-auto px-6">
        {err && <p className="text-sm text-red-600" data-testid="track-error">{err}</p>}
        {order && (
          <div className="bg-white border border-[#E8DCC4] rounded-sm p-6 lg:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#C9A227] font-semibold">Order status</p>
            <h1 className="text-2xl font-display text-neutral-900 mt-2">Order {order.order_id}</h1>
            <p className="text-sm text-neutral-600 mt-1">
              Status: <strong data-testid="track-fulfillment">{STATUS_LABEL[order.fulfillment_status] || order.fulfillment_status}</strong>
              {" · "}{money(order.amount)}
            </p>

            <h2 className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-6 mb-2">Items</h2>
            <ul className="space-y-1 text-sm text-neutral-800" data-testid="track-items">
              {(order.items || []).map((i, idx) => (
                <li key={idx} className="flex justify-between gap-3">
                  <span>{i.name}{i.quantity > 1 ? ` × ${i.quantity}` : ""}</span>
                  <span>{money(i.price)}</span>
                </li>
              ))}
            </ul>

            {(order.shipments || []).length > 0 && (
              <>
                <h2 className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-6 mb-2">Shipments</h2>
                <ul className="space-y-2" data-testid="track-shipments">
                  {order.shipments.map((s, idx) => (
                    <li key={idx} className="rounded border border-[#EFE7D5] p-3 text-sm flex items-center justify-between gap-3">
                      <div>
                        <p className="font-semibold text-neutral-900">{s.carrier} · {s.tracking_number}</p>
                        <p className="text-xs text-neutral-500">Shipped {s.ship_date ? new Date(s.ship_date).toLocaleDateString() : ""}</p>
                      </div>
                      {s.tracking_url && (
                        <a href={s.tracking_url} target="_blank" rel="noreferrer"
                           className="text-[#A8871B] font-semibold text-sm hover:underline"
                           data-testid={`track-link-${idx}`}>Track package</a>
                      )}
                    </li>
                  ))}
                </ul>
              </>
            )}

            <p className="text-xs text-neutral-500 mt-6">
              Questions? Call or WhatsApp (346) 307-7864, or visit your <Link to="/account" className="text-[#A8871B] underline">account</Link>.
            </p>
          </div>
        )}
      </section>
      <Footer />
    </main>
  );
}
